import React from 'react';
import { AnyProps } from '@tanium/coreui-utils';
import { Box } from '@tanium/react-box';
import { css, cx } from '@tanium/react-emotion-9';

export interface Props extends AnyProps {
  /**
   * The string identifier for the region to be occupied by this cell.
   */
  area: string;
  /**
   * Any additional class which must be applied to the grid cell.
   */
  className?: string;
  /**
   * The component to which grid-styling should be applied. Defaults to `Box`. Use sparingly.
   */
  component?: React.ReactType;
}

export function GridCell({ area, className, component, cssMap, ...rest }: Props) {
  const Component = component || Box;
  return <Component className={cx(css(cssMap[area]), className)} {...rest} />;
}
